import React, { useEffect, useRef, useState } from 'react';
import { ImageFrame } from '../../../media';
import IllustrationMedia from '../../../media/IllustrationMedia';
import { normalizeMediaSource } from '../../../media/mediaSource';
import classes from './ScrollStoryBlock.module.css';

export default function StoryMedia({ media, alt, isEditing, ratio, blockId, path, active = true }) {
  const rootRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const resolved = normalizeMediaSource(media);
  const video = resolved.kind === 'video';
  useEffect(() => {
    if (!video || isEditing || !rootRef.current) return undefined;
    const root = rootRef.current;
    const doc = root.ownerDocument;
    const view = doc.defaultView;
    if (typeof view.IntersectionObserver === 'function') {
      const observer = new view.IntersectionObserver((entries) => setVisible(entries.some((entry) => entry.isIntersecting)), { threshold: 0 });
      observer.observe(root);
      return () => observer.disconnect();
    }
    const update = () => {
      const rect = root.getBoundingClientRect();
      setVisible(rect.bottom > 0 && rect.top < view.innerHeight);
    };
    doc.addEventListener('scroll', update, true);
    view.addEventListener('resize', update);
    update();
    return () => {
      doc.removeEventListener('scroll', update, true);
      view.removeEventListener('resize', update);
    };
  }, [video, isEditing]);

  const posterOnly = video && (!visible || !active) && !isEditing;
  return (
    <div ref={rootRef} className={`${classes.media} ${isEditing && !resolved.src ? classes.emptyMedia : ''}`} style={{ aspectRatio: ratio }}>
      {isEditing && !resolved.src && <p>Choisissez l’illustration de cette étape dans l’inspecteur.</p>}
      {posterOnly ? (resolved.poster ? <ImageFrame src={resolved.poster} alt={alt} mediaAspectRatio={ratio} /> : null) : <IllustrationMedia media={media} alt={alt} isEditing={isEditing} mediaFit="cover" mediaAspectRatio={ratio} blockId={blockId} path={path} />}
    </div>
  );
}
